export default {
  geolocation: {
    lat: '46.9480',
    lng: '7.4474',
    label: '3300 Bern',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
